// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__RmlfY","header":"PatientBlock_header__2546i","label":"PatientBlock_label__3n_vy","option":"PatientBlock_option__3rxSg"};